// only triggers build.  the style sheet must be included on page manually.
// output name = name of this ts file (not the scss file).
import "../css/productDetail.scss";

import {
  trackViewItemEvent,
  trackAddToCartEvent,
} from "../js/analytics/analytics-events";
import { getProductFromPage } from "../js/analytics/page-elements";
import { setupProductGallery } from "../loaders/image-gallery";

function isHomeDelivery() {
  const deliveryInfo = document.querySelector("div[id*='deliveryInfo']");
  return (
    deliveryInfo &&
    deliveryInfo.textContent &&
    deliveryInfo.textContent.toLowerCase().includes("home delivery")
  );
}

function insertDeliveryTermsBlock(productDescription: HTMLElement) {
  if (!document.getElementById("terms_of_delivery")) {
    productDescription.insertAdjacentHTML(
      "afterbegin",
      `<section class="delivery-terms">
        <h3>Terms of Delivery</h3>
        <p>
          <b>HOME DELIVERY ONLY:&nbsp; </b>
              This item is drop shipped and can typically take about 3-5 business days for delivery. It can only be delivered to a home address and <b>will not ship to a hospital or medical facility.</b>
        </p>
        <p><u>Please provide the recipient's home address in the special instructions at checkout.</u></p><p><b>Delivery within the U.S. ONLY, excluding Alaska and Hawaii.</b>
        </p>
        <div class="checkbox_delivery">
          <input type="checkbox" id="terms_of_delivery" name="terms_of_delivery" autocomplete="off">
          <label for="terms_of_delivery">Select to Approve Home Delivery Terms</label>
        </div>
      </section>`
    );
  }
}

function setupHomeDeliveryBlock(addToCart: HTMLElement, productDescription: HTMLElement) {
  insertDeliveryTermsBlock(productDescription);

  const checkbox = document.getElementById("terms_of_delivery") as HTMLInputElement;
  if (!checkbox) return;

  const checkboxContainer = checkbox.parentElement;
  if (!checkboxContainer) return;

  // Disable the button initially
  addToCart.classList.add("delivery-terms-disabled");
  addToCart.textContent = "Approve Terms of Delivery";

  if (checkbox && addToCart) {
    checkbox.addEventListener("change", function () {
      if (checkbox.checked) {
        addToCart.classList.add("delivery-terms-enabled");
        addToCart.classList.remove("delivery-terms-disabled");
        addToCart.textContent = "Add To Cart";
        checkboxContainer.innerHTML = `<p class="user-acknowledged">✔️ Terms of Delivery Acknowledged </p>`
      }
    });
  }
}

function trySetup() {
  if (!isHomeDelivery()) return;

  const productDescription = document.querySelector(".description");
  const addToCart = document.querySelector(".prod-button");

  if (productDescription && addToCart) {
    setupHomeDeliveryBlock(addToCart as HTMLElement, productDescription as HTMLElement);
    return true;
  }
  return false;
}

if (isHomeDelivery()) {
  //Initial run
  const setupComplete = trySetup();

  if (!setupComplete) {
    const productInfoNode = document.querySelector(".product-info") as HTMLElement | null;
    if (productInfoNode) {
      const observer = new MutationObserver(() => {
        if (trySetup()) {
          observer.disconnect();
        }
      });

      observer.observe(productInfoNode, {
        childList: true,
        subtree: true
      });
    }
  }
}

/*
  Track statistics about this project view
*/
const script = document.createElement("script");
script.setAttribute("type", "application/ld+json");

const prod = getProductFromPage();

if (prod) {
  const jsonLD = {
    "@context": "https://schema.org/",
    "@type": "Product",
    name: prod.item_name,
    image: prod.image,
    description: prod.description,
    offers: {
      "@type": "Offer",
      url: window.location.href,
      priceCurrency: "USD",
      price: prod.price,
    },
  };

  script.innerText = JSON.stringify(jsonLD);
  document.head.insertAdjacentElement("beforeend", script);

  trackViewItemEvent(prod);
  trackAddToCartEvent(prod);
}

window["setupProductGallery"] = setupProductGallery;

